module.exports = __webpack_public_path__ + "static/media/shopping-basket.88539570.svg";